module.exports = __webpack_public_path__ + "pc/img/publisher.8b54fe72.webp";